import { PaginationResponse } from "../../Shared/Pagination/PaginationResponse";
import { getApi, postApiPagination } from "../../Shared/Services/RestService";
import {
  EventLogResponseDTO,
  EventLogSearchRequestDTO,
  EventLogStatsDTO,
} from "../Types/EventLogs";

export const searchEventLogs = (
  payload: EventLogSearchRequestDTO,
  page: number = 0,
  size: number = 50
) => {
  const params: any = { page, size };
  return postApiPagination<PaginationResponse<EventLogResponseDTO>>(
    "admin/event-logs/search",
    payload,
    params
  );
};

export const getEventLogStats = (from?: string) => {
  const params: any = {};
  if (from) {
    params.from = from;
  }
  return getApi<EventLogStatsDTO>("/admin/event-logs/stats", params);
};